"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionDetailsTab = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var material_1 = require("@mui/material");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var react_use_clipboard_1 = __importDefault(require("react-use-clipboard"));
var doshx_controls_web_1 = require("doshx_controls_web");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var main_1 = require("../../../reducers/slices/main");
var get_auction_1 = require("../../../api/calls/auction/v3/get_auction");
var update_auction_1 = require("../../../api/calls/auction/v3/update_auction");
var create_auction_1 = require("../../../api/calls/auction/v3/create_auction");
var textarea_1 = require("../../../controls/textarea/textarea");
var datepicker_1 = __importDefault(require("../../../controls/datepicker/basic/datepicker"));
var AddressSearchControl_1 = require("../../../components/AddressSearchControl");
var AuctionDetailsTab = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
    var auction_id = props.auction_id, onSave = props.onSave;
    var auctionTypes = ["Collectables", "Collector Cars", "Livestock", "Machinery", "Real Estate", "Vehicles/Trucks"];
    var auctionStatuses = ["Complete", "In-Progress", "Upcoming"];
    var dispatch = (0, react_redux_1.useDispatch)();
    var selectedClient = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).selectedClient;
    var _4 = (0, react_1.useState)(false), isSaving = _4[0], setIsSaving = _4[1];
    var _5 = (0, react_1.useState)({
        title: "",
        registration_fee: "",
        youtube_url: "",
        contact_details: {
            email: "",
            phone: {
                country_code: "ZA",
                calling_code: "+27",
                number: "",
            },
            whatsapp: {
                country_code: "ZA",
                calling_code: "+27",
                number: "",
            },
        },
    }), auction = _5[0], setAuction = _5[1];
    var _6 = (0, react_use_clipboard_1.default)((_a = auction === null || auction === void 0 ? void 0 : auction.live_stream) === null || _a === void 0 ? void 0 : _a.stream_name, {
        successDuration: 1000,
    }), isStreamNameCopied = _6[0], copyDolbyStreamName = _6[1];
    var _7 = (0, react_use_clipboard_1.default)((_b = auction === null || auction === void 0 ? void 0 : auction.live_stream) === null || _b === void 0 ? void 0 : _b.token, {
        successDuration: 1000,
    }), isTokenCopied = _7[0], copyDolbyToken = _7[1];
    (0, react_1.useEffect)(function () {
        //     console.log("auction321", auction);
    }, [auction]);
    (0, react_1.useEffect)(function () {
        if (auction_id) {
            // Editing
            (0, get_auction_1.get_auction)({
                entity_id: auction_id,
            }).then(function (response) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
                if (response.data.success) {
                    var auctionData = response.data.content;
                    //TODO this can be removed after our next deploy on the 10th July 2024! vvvvvvv
                    if (auctionData.contact_details) {
                        setAuction(__assign(__assign({}, auctionData), { contact_details: {
                                email: (_a = auctionData.contact_details) === null || _a === void 0 ? void 0 : _a.email,
                                phone: {
                                    country_code: (_c = (_b = auctionData.contact_details) === null || _b === void 0 ? void 0 : _b.phone) === null || _c === void 0 ? void 0 : _c.country_code,
                                    calling_code: (_e = (_d = auctionData.contact_details) === null || _d === void 0 ? void 0 : _d.phone) === null || _e === void 0 ? void 0 : _e.calling_code,
                                    number: (_g = (_f = auctionData.contact_details) === null || _f === void 0 ? void 0 : _f.phone) === null || _g === void 0 ? void 0 : _g.number,
                                },
                                whatsapp: {
                                    country_code: (_j = (_h = auctionData.contact_details) === null || _h === void 0 ? void 0 : _h.whatsapp) === null || _j === void 0 ? void 0 : _j.country_code,
                                    calling_code: (_l = (_k = auctionData.contact_details) === null || _k === void 0 ? void 0 : _k.whatsapp) === null || _l === void 0 ? void 0 : _l.calling_code,
                                    number: (_o = (_m = auctionData.contact_details) === null || _m === void 0 ? void 0 : _m.whatsapp) === null || _o === void 0 ? void 0 : _o.number,
                                },
                            } }));
                        //TODO this can be removed after our next deploy on the 10th July 2024! ^^^^^^^
                    }
                    else {
                        //TODO this can be removed after our next deploy on the 10th July 2024! vvvvvvv
                        if (auctionData === null || auctionData === void 0 ? void 0 : auctionData.contacts) {
                            setAuction(__assign(__assign({}, auctionData), { contact_details: {
                                    email: (_p = auctionData === null || auctionData === void 0 ? void 0 : auctionData.contacts) === null || _p === void 0 ? void 0 : _p.email,
                                    phone: {
                                        country_code: "ZA",
                                        calling_code: "+27",
                                        number: (_q = auctionData === null || auctionData === void 0 ? void 0 : auctionData.contacts) === null || _q === void 0 ? void 0 : _q.cell_number,
                                    },
                                    whatsapp: {
                                        country_code: "ZA",
                                        calling_code: "+27",
                                        number: (_r = auctionData === null || auctionData === void 0 ? void 0 : auctionData.contacts) === null || _r === void 0 ? void 0 : _r.whatsapp,
                                    },
                                } }));
                        }
                        //TODO this can be removed after our next deploy on the 10th July 2024! ^^^^^^^
                    }
                }
                else {
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.data.message] }));
                }
            });
        }
        else {
            // New
            setAuction(__assign(__assign({}, auction), { automated: {
                    enabled: true,
                }, status: "Upcoming", date_from: (0, moment_timezone_1.default)().tz("Africa/Johannesburg"), date_to: (0, moment_timezone_1.default)().tz("Africa/Johannesburg") }));
        }
    }, [auction_id]);
    var fieldChanged = function (name, value) {
        var _a;
        setAuction(__assign(__assign({}, auction), (_a = {}, _a[name] = value, _a)));
    };
    var validate = function () {
        var _a, _b;
        var messages = [];
        //     console.log("auction", auction);
        if ((_a = auction.automated) === null || _a === void 0 ? void 0 : _a.soft_closing) {
            // Minimum 1 minute for timeout of enabled
            if (auction.automated.soft_closing.enabled && auction.automated.soft_closing.timeout < 1) {
                messages.push("Timeout must be 1 minute or more for Soft-Closing.");
            }
        }
        if (!auction.title) {
            messages.push("Title is required.");
        }
        if (!auction.description) {
            messages.push("Description is required.");
        }
        if (!auction.location || auction.location.full_address.length == 0) {
            messages.push("Address is required.");
        }
        if (!auction.date_from) {
            messages.push("Date From is required.");
        }
        //     console.log("auction.date_to", auction.date_to);
        if (!auction.date_to) {
            messages.push("Date To is required.");
        }
        else {
            var dateValidation = validateDates(auction.date_from, auction.date_to);
            if (dateValidation) {
                messages.push(dateValidation);
            }
        }
        // if (!auction.youtube_url) {
        //   messages.push("Youtube URL is required.");
        // }
        if (auction.status == null) {
            messages.push("Status is required.");
        }
        if (auction.type == null) {
            messages.push("Type is required.");
        }
        //     console.log("auction.contact_details?.phone", auction.contact_details?.phone);
        // const phoneNumber = `${auction.contact_details?.phone?.calling_code}${auction.contact_details?.phone?.number}`;
        // console.log("phoneNumber", phoneNumber);
        // if (!validatePhoneNumber(phoneNumber)) {
        //   messages.push("Phone number is invalid. Please check the country code and number length.");
        // }
        if (((_b = auction.contact_details) === null || _b === void 0 ? void 0 : _b.email) == null) {
            messages.push("Email is required.");
        }
        // const whatsappNumber = `${auction.contact_details?.whatsapp?.calling_code}${auction.contact_details?.whatsapp?.number}`;
        // console.log("whatsappNumber", whatsappNumber);
        // if (!validatePhoneNumber(whatsappNumber)) {
        //   messages.push("Whatsapp number is invalid. Please check the country code and number length.");
        // }
        if (messages && messages.length > 0) {
            dispatch((0, main_1.setMessageModal)({ title: "Validation failed!", messages: messages }));
            return false;
        }
        else {
            return true;
        }
    };
    var validateDates = function (date_from, date_to) {
        //     console.log("date_from", date_from);
        //     console.log("date_to", date_to);
        if (!date_to || !date_from) {
            return "";
        }
        // Check if date_to is less than date_from
        if (date_to <= date_from) {
            return "Date To must be greater than Date From.";
        }
        // Calculate the time difference in minutes
        //     console.log("date_to", date_to);
        //     console.log("date_from", date_from);
        var differenceInMinutes = (date_to - date_from) / (1000 * 60);
        //     console.log("differenceInMinutes", differenceInMinutes);
        // Check if the difference is less than 2 minutes
        if (differenceInMinutes < 2) {
            return "The time difference must be 2 minutes or more.";
        }
    };
    //   console.log("auctionFRED", auction);
    return (react_1.default.createElement("div", { className: "flex flex-col w-full" }, auction ? (react_1.default.createElement("div", { className: "flex flex-col space-y-4 p-4 w-full" },
        react_1.default.createElement("div", { className: "flex flex-row gap-4 justify-start" }, auction_id ? (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Update Details", 
            // theme="blue"
            size: "small", loading: isSaving, backgroundColor: "bg-green-500", onClick: function () {
                if (validate()) {
                    setIsSaving(true);
                    (0, update_auction_1.update_auction)({
                        entity_id: auction_id,
                        entity: {
                            is_popular: auction.is_popular,
                            is_top_auction: auction.is_top_auction,
                            automated: auction.automated,
                            title: auction.title,
                            description: auction.description,
                            contacts: auction === null || auction === void 0 ? void 0 : auction.contacts,
                            contact_details: auction.contact_details,
                            youtube_url: auction.youtube_url,
                            location: auction.location,
                            date_from: auction.date_from,
                            date_to: auction.date_to,
                            status: auction.status,
                            type: auction.type,
                            registration_fee: auction.registration_fee,
                        },
                    }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            setIsSaving(false);
                            if (response.data.success) {
                                onSave(response.data.content);
                                setAuction(response.data.content);
                                dispatch((0, main_1.setMessageModal)({
                                    title: "Success!",
                                    messages: ["Auction updated successfully."],
                                }));
                            }
                            else {
                                dispatch((0, main_1.setMessageModal)({ title: "Something went wrong while updating the auction!", messages: [response.data.message] }));
                            }
                            return [2 /*return*/];
                        });
                    }); });
                }
            } })) : (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Create Auction", 
            // theme="blue"
            size: "small", loading: isSaving, backgroundColor: "bg-green-500", onClick: function () {
                var _a, _b, _c, _d, _e, _f, _g;
                if (validate()) {
                    setIsSaving(true);
                    (0, create_auction_1.create_auction)({
                        client_entity_id: selectedClient.entity_id,
                        is_top_auction: auction.is_top_auction,
                        is_popular: auction.is_popular,
                        automated: {
                            enabled: (_b = (_a = auction.automated) === null || _a === void 0 ? void 0 : _a.enabled) !== null && _b !== void 0 ? _b : false,
                            soft_closing: {
                                enabled: (_e = (_d = (_c = auction.automated) === null || _c === void 0 ? void 0 : _c.soft_closing) === null || _d === void 0 ? void 0 : _d.enabled) !== null && _e !== void 0 ? _e : false,
                                timeout: (_g = (_f = auction.automated) === null || _f === void 0 ? void 0 : _f.soft_closing) === null || _g === void 0 ? void 0 : _g.timeout,
                            },
                        },
                        title: auction.title,
                        description: auction.description,
                        contacts: auction === null || auction === void 0 ? void 0 : auction.contacts,
                        contact_details: auction.contact_details,
                        youtube_url: auction.youtube_url,
                        location: auction.location,
                        date_from: auction.date_from,
                        date_to: auction.date_to,
                        status: auction.status,
                        type: auction.type,
                        registration_fee: auction.registration_fee,
                    }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            setIsSaving(false);
                            if (response.data.success) {
                                // navigate("/console/auctions"); // ??
                                dispatch((0, main_1.setMessageModal)({
                                    title: "Success!",
                                    messages: ["Auction created successfully."],
                                }));
                                onSave(response.data.content);
                            }
                            else {
                                dispatch((0, main_1.setMessageModal)({ title: "Something went wrong while creating the auction!", messages: [response.data.message] }));
                            }
                            return [2 /*return*/];
                        });
                    }); });
                }
            } }))),
        react_1.default.createElement("div", { className: "flex flex-row gap-8" },
            react_1.default.createElement(doshx_controls_web_1.BoxControl, { addPadding: false, borderColor: "border-bluer", className: "px-4 flex gap-4 border-2" },
                react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "Automated Auction?", value: (_c = auction.automated) === null || _c === void 0 ? void 0 : _c.enabled, onChange: function (v) {
                        // fieldChanged("is_automated", v);
                        setAuction(__assign(__assign({}, auction), { automated: __assign(__assign({}, auction.automated), { enabled: v }) }));
                    } }),
                ((_d = auction.automated) === null || _d === void 0 ? void 0 : _d.enabled) && (react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "Soft-Close Lots?", value: (_e = auction.automated.soft_closing) === null || _e === void 0 ? void 0 : _e.enabled, onChange: function (v) {
                        setAuction(__assign(__assign({}, auction), { automated: __assign(__assign({}, auction.automated), { soft_closing: __assign(__assign({}, auction.automated.soft_closing), { enabled: v }) }) }));
                    } })),
                ((_f = auction.automated) === null || _f === void 0 ? void 0 : _f.enabled) && ((_h = (_g = auction.automated) === null || _g === void 0 ? void 0 : _g.soft_closing) === null || _h === void 0 ? void 0 : _h.enabled) && (react_1.default.createElement("div", { className: "py-4 w-28" },
                    react_1.default.createElement(doshx_controls_web_1.TimeoutSelectorControl, { label: "Timeout", views: ["minutes"], value: moment_timezone_1.default.duration((_k = (_j = auction.automated) === null || _j === void 0 ? void 0 : _j.soft_closing) === null || _k === void 0 ? void 0 : _k.timeout, "seconds").asMilliseconds(), size: "small", onChange: function (v) {
                            setAuction(__assign(__assign({}, auction), { automated: __assign(__assign({}, auction.automated), { soft_closing: __assign(__assign({}, auction.automated.soft_closing), { timeout: moment_timezone_1.default.duration(v).asSeconds() }) }) }));
                        } })))),
            react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "Is Popular?", value: auction.is_popular, onChange: function (v) {
                    fieldChanged("is_popular", v);
                } }),
            react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "Is Top Auction?", value: auction.is_top_auction, onChange: function (v) {
                    fieldChanged("is_top_auction", v);
                } })),
        !((_l = auction.automated) === null || _l === void 0 ? void 0 : _l.enabled) && ((_m = auction.live_stream) === null || _m === void 0 ? void 0 : _m.id) && (react_1.default.createElement("div", { className: "bg-gray-200 rounded-xl p-4" },
            react_1.default.createElement("div", { className: "text-lg font-bold" }, "Dolby Live Streaming Details"),
            react_1.default.createElement("div", { className: "underline" }, "Stream Name"),
            react_1.default.createElement("div", { className: "flex items-center" },
                react_1.default.createElement("div", null, (_o = auction === null || auction === void 0 ? void 0 : auction.live_stream) === null || _o === void 0 ? void 0 : _o.stream_name),
                react_1.default.createElement(material_1.IconButton, { color: "primary", "aria-label": "upload picture", component: "span", onClick: function () {
                        //                     console.log("here1");
                        copyDolbyStreamName();
                    } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: isStreamNameCopied ? pro_light_svg_icons_1.faCheck : pro_light_svg_icons_1.faCopy }))),
            react_1.default.createElement("div", { className: "underline" }, "Publishing Token"),
            react_1.default.createElement("div", { className: "flex items-center" },
                react_1.default.createElement("div", null, (_p = auction === null || auction === void 0 ? void 0 : auction.live_stream) === null || _p === void 0 ? void 0 : _p.token),
                react_1.default.createElement(material_1.IconButton, { color: "primary", "aria-label": "upload picture", component: "span", onClick: function () {
                        //                     console.log("here2");
                        copyDolbyToken();
                    } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: isTokenCopied ? pro_light_svg_icons_1.faCheck : pro_light_svg_icons_1.faCopy }))))),
        react_1.default.createElement("div", { className: "flex flex-row gap-4" },
            react_1.default.createElement("div", { className: "flex-1" },
                react_1.default.createElement(AddressSearchControl_1.AddressSearchControl, { label: "Location (Search Address)", placeholder: "Search for an address", letsTradeAPIUrl: process.env.API_URL, value: {
                        fullAddress: (_q = auction === null || auction === void 0 ? void 0 : auction.location) === null || _q === void 0 ? void 0 : _q.full_address,
                        coordinates: {
                            lat: (_r = auction === null || auction === void 0 ? void 0 : auction.location) === null || _r === void 0 ? void 0 : _r.latitude,
                            lng: (_s = auction === null || auction === void 0 ? void 0 : auction.location) === null || _s === void 0 ? void 0 : _s.longitude,
                        },
                    }, onSelectionChange: function (address) {
                        // console.log("address", address);
                        fieldChanged("location", {
                            full_address: address.fullAddress,
                            latitude: address.coordinates.lat,
                            longitude: address.coordinates.lng,
                        });
                    }, labelColor: "text-black", textColor: "text-black" })),
            react_1.default.createElement("div", { className: "flex-1 flex gap-4" },
                react_1.default.createElement("div", { className: "flex-1" },
                    react_1.default.createElement(datepicker_1.default, { label: "From Date & Time", value: auction.date_from, onChange: function (v) {
                            if (v) {
                                //                       console.log("v123", v.format("YYYY/MM/DD HH:mm"));
                                fieldChanged("date_from", (0, moment_timezone_1.default)(v).tz("Africa/Johannesburg"));
                            }
                            else {
                                fieldChanged("date_from", null);
                            }
                        }, colors: {
                            labelColor: "#000000",
                            // backgroundColor: "#ffff80",
                            textColor: "#000000",
                            borderColor: "#000000",
                            // iconColor: "#800080",
                        } })),
                react_1.default.createElement("div", { className: "flex-1" },
                    react_1.default.createElement(datepicker_1.default, { label: "To Date & Time", value: auction.date_to, errorText: validateDates(auction.date_from, auction.date_to), onChange: function (v) {
                            var fields = {
                                date_to: null,
                            };
                            if (v) {
                                fields = {
                                    date_to: (0, moment_timezone_1.default)(v).tz("Africa/Johannesburg"),
                                };
                            }
                            // set the status to upcoming if the date is in the future.
                            if ((0, moment_timezone_1.default)(v).isAfter((0, moment_timezone_1.default)())) {
                                fields.status = "Upcoming";
                            }
                            else if ((0, moment_timezone_1.default)(v).isBefore((0, moment_timezone_1.default)())) {
                                fields.status = "Complete";
                            }
                            setAuction(__assign(__assign({}, auction), fields));
                        }, colors: {
                            labelColor: "#000000",
                            // backgroundColor: "#ffff80",
                            textColor: "#000000",
                            borderColor: "#000000",
                            // iconColor: "#800080",
                        } })))),
        react_1.default.createElement("div", { className: "flex gap-4" },
            react_1.default.createElement("div", { className: "flex-1 flex flex-col gap-4" },
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Title", value: auction.title, onChange: function (v) { return fieldChanged("title", v); } }),
                react_1.default.createElement(textarea_1.TextAreaControl, { label: "Description", lines: 8, value: auction.description, onChange: function (v) { return fieldChanged("description", v); } })),
            react_1.default.createElement("div", { className: "flex-1 flex flex-row gap-4" },
                react_1.default.createElement("div", { className: "flex-1 flex flex-col gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.NewDropdownControl, { label: "Type", value: auction.type, renderDisplay: function (item) { return item; }, options: auctionTypes, onChange: function (v) { return fieldChanged("type", v); }, colors: {
                            borderColor: "border-black",
                            labelColor: "text-black",
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.NewDropdownControl, { label: "Status", value: auction.status, renderDisplay: function (item) { return item; }, options: auctionStatuses, onChange: function (v) { return fieldChanged("status", v); }, colors: {
                            borderColor: "border-black",
                            labelColor: "text-black",
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Registration Fee (ZAR)", value: auction.registration_fee, type: "number", onChange: function (v) { return fieldChanged("registration_fee", v); } }),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Youtube URL", value: auction.youtube_url, onChange: function (v) { return fieldChanged("youtube_url", v); } })),
                react_1.default.createElement("div", { className: "flex-1 flex flex-col gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.PhoneInputControl, { label: "Phone number", value: (_v = (_u = (_t = auction.contact_details) === null || _t === void 0 ? void 0 : _t.phone) === null || _u === void 0 ? void 0 : _u.number) !== null && _v !== void 0 ? _v : "", defaultCountryCode: "ZA", countryCodeValue: (_x = (_w = auction.contact_details) === null || _w === void 0 ? void 0 : _w.phone) === null || _x === void 0 ? void 0 : _x.country_code, size: "medium", onChange: function (v) {
                            var _a;
                            setAuction(__assign(__assign({}, auction), { contact_details: __assign(__assign({}, auction.contact_details), { phone: __assign(__assign({}, (_a = auction.contact_details) === null || _a === void 0 ? void 0 : _a.phone), { number: v }) }) }));
                        }, onExtensionChange: function (ext, cc) {
                            var _a;
                            var qwe = __assign(__assign({}, auction), { contact_details: __assign(__assign({}, auction.contact_details), { phone: __assign(__assign({}, (_a = auction.contact_details) === null || _a === void 0 ? void 0 : _a.phone), { country_code: cc, calling_code: ext }) }) });
                            //                     console.log("onExtensionChange", qwe);
                            setAuction(qwe);
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Email address", value: (_y = auction.contact_details) === null || _y === void 0 ? void 0 : _y.email, type: "text", onChange: function (v) { return fieldChanged("contact_details", __assign(__assign({}, auction.contact_details), { email: v })); } }),
                    react_1.default.createElement(doshx_controls_web_1.PhoneInputControl, { label: "Whatsapp number", value: (_1 = (_0 = (_z = auction.contact_details) === null || _z === void 0 ? void 0 : _z.whatsapp) === null || _0 === void 0 ? void 0 : _0.number) !== null && _1 !== void 0 ? _1 : "", defaultCountryCode: "ZA", countryCodeValue: (_3 = (_2 = auction.contact_details) === null || _2 === void 0 ? void 0 : _2.whatsapp) === null || _3 === void 0 ? void 0 : _3.country_code, size: "medium", onChange: function (v) {
                            var _a;
                            setAuction(__assign(__assign({}, auction), { contact_details: __assign(__assign({}, auction.contact_details), { whatsapp: __assign(__assign({}, (_a = auction.contact_details) === null || _a === void 0 ? void 0 : _a.whatsapp), { number: v }) }) }));
                        }, onExtensionChange: function (ext, cc) {
                            var _a;
                            setAuction(__assign(__assign({}, auction), { contact_details: __assign(__assign({}, auction.contact_details), { whatsapp: __assign(__assign({}, (_a = auction.contact_details) === null || _a === void 0 ? void 0 : _a.whatsapp), { country_code: cc, calling_code: ext }) }) }));
                        } })))))) : (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "large" })))));
};
exports.AuctionDetailsTab = AuctionDetailsTab;
